import { render, staticRenderFns } from "./DashboardListing.vue?vue&type=template&id=4f6efc8f&"
import script from "./DashboardListing.vue?vue&type=script&lang=js&"
export * from "./DashboardListing.vue?vue&type=script&lang=js&"
import style0 from "./DashboardListing.vue?vue&type=style&index=0&id=4f6efc8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports